'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  clearfix: _propTypes2.default.bool
};

var cssClearfix = (0, _glamor.css)({
  '&:before, &:after': {
    display: 'table',
    clear: 'both',
    content: '""'
  }
});

var parseProps = exports.parseProps = function parseProps(_ref) {
  var clearfix = _ref.clearfix,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['clearfix', 'className']);

  return _extends({
    className: clearfix ? (0, _classnames2.default)('' + cssClearfix, className) : className
  }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvY2xlYXJmaXguanMiXSwibmFtZXMiOlsicHJvcFR5cGVzIiwiY2xlYXJmaXgiLCJib29sIiwiY3NzQ2xlYXJmaXgiLCJkaXNwbGF5IiwiY2xlYXIiLCJjb250ZW50IiwicGFyc2VQcm9wcyIsImNsYXNzTmFtZSIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7OztBQUNBOztBQUNBOzs7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxZQUFVLG9CQUFVQztBQURHLENBQWxCOztBQUlQLElBQU1DLGNBQWMsaUJBQUk7QUFDdEIsdUJBQXFCO0FBQ25CQyxhQUFTLE9BRFU7QUFFbkJDLFdBQU8sTUFGWTtBQUduQkMsYUFBUztBQUhVO0FBREMsQ0FBSixDQUFwQjs7QUFRTyxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhO0FBQUEsTUFBR04sUUFBSCxRQUFHQSxRQUFIO0FBQUEsTUFBYU8sU0FBYixRQUFhQSxTQUFiO0FBQUEsTUFBMkJDLEtBQTNCOztBQUFBO0FBQ3hCRCxlQUFXUCxXQUFXLCtCQUFNRSxXQUFOLEVBQXFCSyxTQUFyQixDQUFYLEdBQTZDQTtBQURoQyxLQUVyQkMsS0FGcUI7QUFBQSxDQUFuQiIsImZpbGUiOiJjbGVhcmZpeC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCB7IGNzcyB9IGZyb20gJ2dsYW1vcidcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICBjbGVhcmZpeDogUHJvcFR5cGVzLmJvb2xcbn1cblxuY29uc3QgY3NzQ2xlYXJmaXggPSBjc3Moe1xuICAnJjpiZWZvcmUsICY6YWZ0ZXInOiB7XG4gICAgZGlzcGxheTogJ3RhYmxlJyxcbiAgICBjbGVhcjogJ2JvdGgnLFxuICAgIGNvbnRlbnQ6ICdcIlwiJ1xuICB9XG59KVxuXG5leHBvcnQgY29uc3QgcGFyc2VQcm9wcyA9ICh7IGNsZWFyZml4LCBjbGFzc05hbWUsIC4uLnByb3BzIH0pID0+ICh7XG4gIGNsYXNzTmFtZTogY2xlYXJmaXggPyBjeChgJHtjc3NDbGVhcmZpeH1gLCBjbGFzc05hbWUpIDogY2xhc3NOYW1lLFxuICAuLi5wcm9wc1xufSlcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/clearfix.js
// module id = 1143
// module chunks = 0